__turbopack_context__.v({
  "brandCard": "_9ltl7a_brandCard",
  "brandCardInfo": "_9ltl7a_brandCardInfo",
  "brandCardLink": "_9ltl7a_brandCardLink",
  "brandCardLogo": "_9ltl7a_brandCardLogo",
  "brandCardMeta": "_9ltl7a_brandCardMeta",
  "brandCardName": "_9ltl7a_brandCardName",
  "brandsPageMain": "_9ltl7a_brandsPageMain",
});
